var React = require('react');

function ArrowsRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 3L21.2 9L14 15","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M5 3L12.2 9L5 15","strokeWidth":"2","key":1})]);
}

ArrowsRight.defaultProps = {"width":"27","height":"18","viewBox":"0 0 27 18"};

module.exports = ArrowsRight;

ArrowsRight.default = ArrowsRight;
